<template>
  <AtomicUiCard padding-class="padding-0" class="registry-card search-registry text-center small-12 medium-6 xlarge-5">
    <div class="grid-x text-center registry-card-header-section">
      <div class="h4 registry-card-header small-12">Find a Registry</div>
      <div v-if="findSubheaderText" class="input-text">
        {{ findSubheaderText }}
      </div>
    </div>
    <SearchRegistryBarForm
      ref="searchRegistryBarForm"
      :search-bar-style="searchBarStyle"
      :occasion="isBabyLanding ? 'baby' : 'wedding'"
      class="search-registry-bar-wrapper"
    />
  </AtomicUiCard>
</template>

<script setup>
import SearchRegistryBarForm from '~/components/SearchRegistry/SearchRegistryBarForm';
import { SEARCH_BAR_STYLES } from '~/types/searchBarTypes';
import { WeddingLandingPage, BabyLandingPage } from 'config';

const route = useRoute();
const searchRegistryBarForm = ref(null);
const searchBarStyle = SEARCH_BAR_STYLES.COLUMN;
const isBabyLanding = computed(() => !!route.path.includes('/registry/baby'));
const findSubheaderText = computed(() => (isBabyLanding.value ? BabyLandingPage.FindSubheader : WeddingLandingPage.FindSubheader));

onMounted(() => {
  searchRegistryBarForm.value?.clearSearchInput();
});
</script>

<style lang="scss" brand="mcom" scoped>
@import '~/assets/scss/components/registrySignInStyles.scss';
@import '~@core/foundation/scss/foundation-6.7.4/scss/prototype/_spacing.scss';

.search-registry-bar-wrapper {
  :deep(.search-registry-bar-input-wrapper) {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin-bottom: 0;
    padding: 0 rem-calc(2);

    @include breakpoint(small up) {
      height: rem-calc(131);
    }

    @include breakpoint(medium up) {
      height: rem-calc(152);
    }

    @include breakpoint(large up) {
      height: rem-calc(122);
    }

    @include breakpoint(xlarge up) {
      height: rem-calc(124);
    }

    .form-error {
      text-align: left;
    }
  }

  :deep(.input-container) {
    margin-top: auto;
    margin-bottom: 0;
  }

  :deep(.search-registry-bar-button-wrapper) {
    display: flex;
    align-items: flex-start;
    margin-left: 0;
    margin-right: 0;
    margin-bottom: 0;
    @include margin-direction('top', map-get($spacer, 's'));
    padding: 0 rem-calc(2);

    @include breakpoint(small up) {
      height: rem-calc(75);
    }

    @include breakpoint(medium up) {
      height: rem-calc(110);
    }

    @include breakpoint(large up) {
      height: rem-calc(96);
    }

    @include breakpoint(xlarge up) {
      height: rem-calc(88);
    }
  }
}

.registry-card {
  @include padding-direction('top', map-get($spacer, 'm'));
  @include padding-direction('bottom', map-get($spacer, 'm'));
}
</style>

<style lang="scss" brand="bcom" scoped>
@import '~/assets/scss/components/registrySignInStyles.scss';
@import '~@core/foundation/scss/foundation-6.7.4/scss/prototype/_spacing.scss';
.registry-card-header {
  text-transform: uppercase;
  font-weight: 900;
}

.search-registry-bar-wrapper {
  :deep(.search-registry-bar-input-wrapper) {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    margin-bottom: 0;
    padding: 0 rem-calc(2);

    .input-container {
      width: 100%;
    }

    @include breakpoint(small down) {
      width: rem-calc(295);
      padding: 0px;
    }

    @include breakpoint(small up) {
      height: rem-calc(131);
    }

    @include breakpoint(medium up) {
      height: rem-calc(152);
    }

    @include breakpoint(large up) {
      height: rem-calc(122);
    }

    @include breakpoint(xlarge up) {
      height: rem-calc(124);
    }

    .form-error {
      text-align: left;
    }
  }

  :deep(.input-container) {
    margin-top: auto;
    margin-bottom: 0;
  }

  :deep(.search-registry-bar-button-wrapper) {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    margin-left: 0;
    margin-right: 0;
    margin-bottom: 0;
    padding-left: 0;
    padding-right: 0;

    @include margin-direction('top', map-get($spacer, 's'));
    padding: 0 rem-calc(2);

    @include breakpoint(small up) {
      height: rem-calc(75);
    }
    @include breakpoint(small down) {
      padding: 0px;
    }
    @include breakpoint(medium up) {
      height: rem-calc(110);
    }

    @include breakpoint(large up) {
      height: rem-calc(96);
    }

    @include breakpoint(xlarge up) {
      height: rem-calc(88);
    }
  }

  :deep(.search-registry-button) {
    width: 100%;
  }
}

.registry-card {
  @include padding-direction('top', map-get($spacer, 's'));
  @include padding-direction('bottom', map-get($spacer, 'm'));
  opacity: 0.85;

  max-width: rem-calc(411);

  @include breakpoint(small down) {
    width: rem-calc(335);
  }
}
</style>
